<template>
    <div class="ma-4">
        <v-card>
            <v-layout row wrap class="pa-2 ma-2 hideOnPrint">
                <v-flex xs12>
                    <v-btn fab x-small @click="$router.go(-1)">
                        <v-icon>navigate_before</v-icon>

                    </v-btn>
                </v-flex>

                <v-flex xs12 md1 class="mb-2">
                    <v-btn
                        fab
                        small
                        @click="printTable()"
                        class="ml-8 white--text"
                        color="#2b6993"
                        elevation="4"
                        absolute
                        right
                    >
                        <v-icon>print</v-icon>
                    </v-btn>
                </v-flex>

                <v-flex xs12>
                    <h3 class="text-center mb-5">Medical Visit Report</h3>
                    <v-divider class="ml-4 mr-4 mb-3"></v-divider>
                </v-flex>

                <v-flex xs12>
                    <v-card
                        class="ma-3 pa-3"
                        elevation="0"
                    >
                        <v-layout row wrap>
                            <v-flex xs12 md2 class="pa-1">
                                <v-menu
                                    ref="calendarMenu"
                                    v-model="calendarMenu"
                                    :close-on-content-click="false"
                                    :return-value.sync="date"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="reportFilters.startDate"
                                            label="Start Date"
                                            prepend-icon="mdi-calendar"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                            :rules='requiredField'
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="reportFilters.startDate"
                                        no-title
                                        scrollable
                                        :rules='requiredField'
                                    >
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            text
                                            color="primary"
                                            @click="calendarMenu = false"
                                        >
                                            Cancel
                                        </v-btn>
                                        <v-btn
                                            text
                                            color="primary"
                                            @click="$refs.calendarMenu.save(date)"
                                        >
                                            OK
                                        </v-btn>
                                    </v-date-picker>
                                </v-menu>

                            </v-flex>

                            <v-flex xs12 md2 class="pa-1">
                                <v-menu
                                    ref="calendar2Menu"
                                    v-model="calendar2Menu"
                                    :close-on-content-click="false"
                                    :return-value.sync="date"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="reportFilters.endDate"
                                            label="End Date"
                                            prepend-icon="mdi-calendar"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                            :rules='requiredField'

                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="reportFilters.endDate"
                                        no-title
                                        scrollable
                                        :rules='requiredField'

                                    >
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            text
                                            color="primary"
                                            @click="calendar2Menu = false"
                                        >
                                            Cancel
                                        </v-btn>
                                        <v-btn
                                            text
                                            color="primary"
                                            @click="$refs.calendar2Menu.save(date)"
                                        >
                                            OK
                                        </v-btn>
                                    </v-date-picker>
                                </v-menu>
                            </v-flex>

                            <v-flex xs12 md2 class="pa-1 mb-2">
                                <v-select
                                    label="Select a Program"
                                    :items="programs"
                                    item-text="Name"
                                    item-value="Name"
                                    v-model="reportFilters.program"
                                    clearable
                                    @change="visitQuery()"
                                ></v-select>
                            </v-flex>

                            <v-flex xs12 md2 class="pa-1 mb-2">
                              <v-select
                                label="Client Status"
                                :items="clientStatuses"
                                v-model="reportFilters.clientStatus"
                                clearable
                                @change="visitQuery()"
                                ></v-select>
                            </v-flex>

                            <v-flex xs12 md2 class="pa-1 mb-2">
                                <v-select
                                    label="Select a Client"
                                    :items="filteredClients"
                                    item-text="Name"
                                    item-value="._id"
                                    v-model="reportFilters.ClientID"
                                    clearable
                                    @change="visitQuery()"
                                ></v-select>
                            </v-flex>


                            <v-flex xs12 md3 class="mt-5 mb-5 pl-5">
                                <v-btn @click="visitQuery()">Search</v-btn>
                            </v-flex>
                        </v-layout>
                    </v-card>
                </v-flex>

                <!-- <v-flex xs12 md2 class="pa-1 mb-2"> -->
                <!--                  <v-select-->
                <!--                    :items="states"-->
                <!--                    v-model="state"-->
                <!--                    label="State"-->
                <!--                    clearable-->
                <!--                    @change="incidentQuery"-->
                <!--                  ></v-select>-->
                <!-- <v-switch
                    v-show="userRole === 'Administration'"
                    v-model="isUtahIncidentReports"
                    inset
                    :label="(isUtahIncidentReports ? 'Utah' : 'Nevada') + ' Incident Reports'"
                    @change="visitQuery"
                ></v-switch>
              </v-flex> -->

                <!-- <v-flex xs12 md2 class="pa-1 mb-2">
                  <v-select
                    :items="states"
                    v-model="state"
                    label="State"
                    clearable
                  ></v-select>
                </v-flex> -->

                <v-flex xs12 class="pa-2">
                    <v-data-table
                        :page="page"
                        :pageCount="pageCount"
                        :server-items-length="itemCount"
                        :options.sync="options"
                        :headers="headers"
                        :items="visits"
                        sort-by="Date"
                        sort-desc
                        class="elevation-1"
                        :loading="isLoading"
                        loading-text="Loading Medical Visits"
                        @update:options="visitQuery"
                    >
                        <template v-slot:item.select="{ item }">
                            <v-btn
                                x-small
                                class="white--text"
                                color="#2b3990"
                                @click="showEventForm(item)"
                            >
                                view
                            </v-btn>
                        </template>
                    </v-data-table>
                </v-flex>
            </v-layout>
        </v-card>
        <v-dialog v-model="dialog" max-width="80%">
            <v-card>
                <v-card-title style="background-color: #2b3990">
                    <span class="headline white--text">Viewing Medical Visit</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-form
                            ref="form"
                            lazy-validation>
                            <v-row>
                                <v-col cols="12" sm="12" md="6">
                                    <span>Annual Visit?</span>
                                    <v-row class="ml-0">
                                        <v-switch
                                            readonly
                                            label="Yes"
                                            value="Yes"
                                            v-model="item.annualVisit"
                                        ></v-switch>
                                        <v-switch
                                            readonly
                                            label="No"
                                            value="No"
                                            v-model="item.annualVisit"
                                        ></v-switch>
                                    </v-row>
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                    <v-text-field
                                        readonly
                                        v-model="item.date"
                                        label="Date and Time of Visit"
                                        prepend-icon="mdi-calendar"
                                    >
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="4">
                                    <v-text-field
                                        readonly
                                        v-model="item.visitType"
                                        label="Visit Type"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="4">
                                    <v-text-field
                                        readonly
                                        return-object
                                        label="Reviewing Provider"
                                        v-model="item.reviewingProvider.Name"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <v-text-field
                                        readonly
                                        v-model="item.reviewingProvider.Profession"
                                        label="Provider Type"
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="12" md="6">
                                    <v-text-field
                                        readonly
                                        label="Facility Name"
                                        v-model="item.reviewingProvider.Company"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                    <v-text-field
                                        readonly
                                        label="Facility Address"
                                        v-model="item.reviewingProvider.Address"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                    <v-text-field readonly label="City"
                                                  v-model="item.reviewingProvider.City"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                    <v-text-field readonly label="State"
                                                  v-model="item.reviewingProvider.State"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                    <v-text-field readonly label="Zip"
                                                  v-model="item.reviewingProvider.Zip"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                    <v-text-field
                                        readonly
                                        label="Phone Number"
                                        v-model="item.reviewingProvider.Phone"
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="12" md="12">
                                    <v-textarea
                                        label="Reason for Visit"
                                        v-model="item.reason"
                                        outlined
                                    ></v-textarea>
                                </v-col>

                                <v-col cols="12">
                                    <span>Were there any medication changes?</span>
                                    <v-switch
                                        readonly
                                        label="Yes"
                                        value="Yes"
                                        v-model="item.medChange"
                                    ></v-switch>
                                    <v-switch
                                        readonly
                                        label="No"
                                        value="No"
                                        v-model="item.medChange"
                                    ></v-switch>
                                </v-col>

                                <v-col cols="12">
                                    <v-textarea
                                        readonly
                                        label="What medication(s) was changed?"
                                        outlined
                                        v-model="item.medChangeDescription"
                                    ></v-textarea>
                                </v-col>

                                <v-col cols="12">
                                    <div class="blue darken-4 white--text pa-4">
                                        THIS SECTION SHOULD BE FILLED OUT BY THE STAFF
                                    </div>
                                </v-col>
                                <v-col cols="12" sm="12">
                                    <v-expansion-panels
                                        v-model="panel"
                                        multiple
                                    >
                                        <v-expansion-panel>
                                            <v-expansion-panel-header disable-icon-rotate
                                                                      class="text-uppercase font-weight-bold font-italic info">
                                                Document List
                                                <template v-slot:actions>
                                                    <v-icon>
                                                        mdi-view-list
                                                    </v-icon>
                                                </template>
                                            </v-expansion-panel-header>

                                            <v-expansion-panel-content>
                                                <template>
                                                    <v-card
                                                        class="mx-auto"
                                                        tile
                                                    >
                                                        <v-list dense>
                                                            <v-list-item-group
                                                                color="primary"
                                                            >
                                                                <v-list-item
                                                                    v-for="(item, i) in uploadedDocuments"
                                                                    :key="i"
                                                                >
                                                                    <v-list-item-content>
                                                                        <v-chip
                                                                            class=""
                                                                            color="primary"
                                                                            text-color=""
                                                                            label
                                                                        >
                                                                            {{ item.name }}
                                                                        </v-chip>
                                                                        <div v-if="item.ext !=='pdf' ">
                                                                            <v-img
                                                                                max-height="280"
                                                                                max-width="350"
                                                                                :src="item.aws"
                                                                            ></v-img>
                                                                        </div>
                                                                        <div v-if="item.ext ==='pdf' ">
                                                                            <load-pdf
                                                                                :pdfFile="item.aws"
                                                                                :id="item.id"
                                                                            />
                                                                        </div>
                                                                    </v-list-item-content>
                                                                </v-list-item>
                                                            </v-list-item-group>
                                                        </v-list>
                                                    </v-card>
                                                </template>

                                            </v-expansion-panel-content>
                                        </v-expansion-panel>
                                    </v-expansion-panels>
                                </v-col>
                                <v-col cols="12" sm="12">
                                    <v-col cols="12" sm="12" md="3"
                                           v-for="item in newAdditionalDocuments"
                                           :key="item.aws"
                                    >
                                    </v-col>
                                    <v-expansion-panels
                                        v-model="panel2"
                                        multiple
                                    >
                                        <v-expansion-panel>
                                            <v-expansion-panel-header disable-icon-rotate
                                                                      class="text-uppercase font-weight-bold font-italic info">
                                                Additional Documents List
                                                <template v-slot:actions>
                                                    <v-icon>
                                                        mdi-view-list
                                                    </v-icon>
                                                </template>
                                            </v-expansion-panel-header>
                                            <v-expansion-panel-content>
                                                <template>
                                                    <v-card
                                                        class="mx-auto"
                                                        tile
                                                    >
                                                        <v-list dense>
                                                            <v-list-item-group
                                                                color="primary"
                                                            >
                                                                <v-list-item
                                                                    v-for="(item, i) in uploadedAdditionalDocuments"
                                                                    :key="i"
                                                                >
                                                                    <v-list-item-content>
                                                                        <v-chip
                                                                            class=""
                                                                            color="primary"
                                                                            text-color=""
                                                                            label
                                                                        >
                                                                            {{ item.name }}
                                                                        </v-chip>
                                                                        <div v-if="item.ext !=='pdf' ">
                                                                            <v-img
                                                                                max-height="280"
                                                                                max-width="350"
                                                                                :src="item.aws"
                                                                            ></v-img>
                                                                        </div>
                                                                        <div v-if="item.ext ==='pdf' ">
                                                                            <load-pdf
                                                                                :pdfFile="item.aws"
                                                                                :id="item.id"
                                                                            />
                                                                        </div>
                                                                    </v-list-item-content>
                                                                </v-list-item>
                                                            </v-list-item-group>
                                                        </v-list>
                                                    </v-card>
                                                </template>
                                            </v-expansion-panel-content>
                                        </v-expansion-panel>
                                    </v-expansion-panels>
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                    <v-text-field
                                        readonly
                                        label="Current Weight"
                                        v-model="item.weight"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                    <v-text-field
                                        readonly
                                        label="Current Blood Pressure"
                                        v-model="item.bloodPressure"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12">
                                    <v-textarea
                                        readonly
                                        label="Comments on Visit"
                                        outlined
                                        v-model="item.comments"
                                        :rules="requiredField"
                                    ></v-textarea>
                                </v-col>
                                <v-col cols="12" sm="12" md="12">
                                    <v-checkbox
                                        readonly
                                        label="Follow Up Appointment Needed"
                                        v-model="item.followUp"
                                        @click="showEventDialog(item.followUp)"
                                    ></v-checkbox>
                                </v-col>

                                <v-row class="ma-0">
                                    <v-col cols="12" sm="12" md="6">
                                        <v-text-field
                                            readonly
                                            v-model="item.followUpDate"
                                            label="Date and Time of Follow up Visit"
                                            prepend-icon="mdi-calendar"
                                            v-if="item.followUp"
                                        >
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="6" v-if="item.followUp">
                                        <v-text-field
                                            readonly
                                            v-model="item.followUpDate"
                                            label="Date and Time of Visit"
                                            prepend-icon="mdi-calendar"
                                        >
                                        </v-text-field>
                                    </v-col>
                                </v-row>

                                <v-col cols="12" sm="12" md="12">
                                    <v-text-field
                                        v-model="item.signature"
                                        readonly
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-container>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="white--text" color="#2b3990" @click="dialog = false">
                        Back
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- <add-events-dialog
          :newEvent="newEvent"
          @on-add-event="(item) => onAddEvent(item)"
          @onShowEventDialog="(item) => showEventDialog(item)"
        /> -->

        <div id="print">
            <report-header>
              <h2>Medical Visit Report</h2>
            </report-header>
            <v-row>
                <v-col cols="12">
                    <v-data-table
                        :headers="headers"
                        :items="visits"
                        sort-by="Date"
                        sort-desc
                        class="elevation-1"
                        :loading="isLoading"
                        loading-text="Loading Medical Visits"
                        :items-per-page="-1"
                        @update:options="visitQuery"
                    >
                    </v-data-table>
                </v-col>
            </v-row>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
// import Foot from '../components/Footer'
import {mapState, mapActions} from "vuex";
import LoadPdf from '../client/MedVisit/loadPDF.vue';
// import AddEventsDialog from '@/components/events/addEventsDialog.vue';
import renameFileHelper from '@/mixins/renameFileHelper';
import DateTimeUtil from "../../../utils/date-time.util";
import { STATUS_ARRAY } from '../../enums/UserStatusEnum';
import ReportHeader from '@/components/Report/ReportHeader.vue';
import { DateTime } from 'luxon';
import ReportFilters from '@/mixins/reportFilters.js';


const url = require("../../client_config/config").url;

export default {
    mixins: [renameFileHelper, ReportFilters],
    // components: { LoadPdf, AddEventsDialog },
    components: {
        LoadPdf,
        ReportHeader
    },
    props: {
        newItem: {
            type: Boolean,
            default: true,
        },
        staffName: {
            type: String,
            default: "",
        },
        clientName: {
            type: String,
            default: "",
        }
    },
    data: () => ({
        headers: [
            {text: "Client", align: 'start', value: "ClientInfo.Name", sortable: true,},
            {
                text: 'Start Date',
                value: 'Date',
                sortable: true,
            },
            {text: "Visit Type", value: "VisitType"},
            {text: "Reviewing Provider", value: "ReviewingProvider.Name"},
            {text: "Annual Visit", value: "AnnualVisit"},
            {text: "Signature", value: "Signature"},
            {text: "Med Change", value: "MedChange"},
            // { text: "State", value: "State" },
            {text: "", value: "select"},

        ],
        items: [
            {text: 'Real-Time', icon: 'mdi-close-circle'},
            {text: 'Audience', icon: 'mdi-account'},
            {text: 'Conversions', icon: 'mdi-flag'},
        ],
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        calendarMenu: false,
        calendar2Menu: false,
        dialog: false,
        isLoading: false,
        titleForm: "New Med Visit",
        isDownloadPDF: false,
        isAdditionalPDF: false,
        isDownloadIMAGE: false,
        isAdditionalIMAGE: false,
        visits: [],
        clients: [],
        programs: [],
        providers: [],
        userState: localStorage.getItem('userState'),
        item: {
            annualVisit: "",
            visitType: "",
            reviewingProvider: "",
            providerType: "",
            reason: "",
            medChange: false,
            medChangeDescription: "",
            facility: "",
            address: "",
            city: "",
            state: "",
            zip: "",
            phone: "",
            date: "",
            document: "",
            additionalDocument: "",
            weight: "",
            bloodPressure: "",
            comments: "",
            followUp: "",
            followUpDate: "",
            signature: localStorage.getItem("Name") + " - " + new Date(),
            eventID: "",
        },

        defaultItem: {
            annualVisit: "",
            visitType: "",
            reviewingProvider: "",
            providerType: "",
            reason: "",
            medChange: false,
            medChangeDescription: "",
            facility: "",
            address: "",
            city: "",
            state: "",
            zip: "",
            phone: "",
            date: "",
            document: "",
            additionalDocument: "",
            weight: "",
            bloodPressure: "",
            comments: "",
            followUp: "",
            followUpDate: "",
            signature: localStorage.getItem("Name") + " - " + new Date(),
            eventID: "",
        },
        newVisit: false,
        signed: true,
        visitID: "",
        uploadFile: "",
        uploadFile2: "",
        newDocuments: [],
        uploadedDocuments: [],
        newAdditionalDocuments: [],
        documentPDF: [],
        isDocumentPDF: false,
        uploadedAdditionalDocuments: [],
        documentAdditionalPDF: [],
        requiredField: [
            v => !!v || 'This is required',
        ],
        panel: [0, 1],
        panel2: [0, 1],
        newEvent: true,
        fileCounter: 1,
        state: localStorage.getItem('userState'),
        page: 1,
        pageCount: 1,
        itemCount: 0,
        options: {},
        clientStatuses: STATUS_ARRAY,
        reportFilters:  {
            startDate: '',
            endDate: '',
            clientStatus: '',
            ClientID: '',
            program: ''
        },
        reportFilterName: 'ReportFilters_MedicalVisit'
    }),

    computed: {
        ...mapState({
            staff: (state) => state.users.user.Name,
        }),
        filteredClients() {            
            const clientStatus = this.reportFilters.clientStatus;
            if (!(clientStatus == '' || clientStatus == null)) {
                return this.clients.filter((client) => client.Status == clientStatus);
            }
                
            return this.clients;
        }

    },

    created() {
        this.getClients();
        this.getPrograms();
        this.visitQuery();
        this.reportFilters = this.getReportFilters(this.reportFilterName) ?? this.reportFilters;
    },    

    watch: {
      reportFilters: {
          handler(newVal) {
              this.setReportFilters(this.reportFilterName, newVal);
          },
          deep: true
      }
    },

    methods: {
        ...mapActions("medicalVisit", ["addItem"]),

        validate() {
            return this.$refs.form.validate();
        },
        validateReset() {
            if (this.$refs.form != undefined) {
                this.$refs.form.reset();
            }
        },

        showEventForm(item) {
            const id = item._id;
            const clientID = item.ClientID;

            this.$router.push({ path: `/medVisit/${clientID}/view-visit/${id}`,
                    query: {clientNav: 'false', 'newVisit': 'false'}
            });
        },

        async getClients() {
            let params = {};
            let endpoint = `${url}/clients`;

            const companyIds = localStorage.getItem('userCompanies');

            params['Company:in'] = JSON.parse(companyIds);
            params['State'] = this.userState;

            await axios.get(endpoint, {params})
                .then((res) => {
                    this.clients = res.data.clients;
                });
        },

        async getPrograms() {
            await axios.get(`${url}/units/state/${this.userState}`)
                .then((res) => {
                    this.programs = res.data.units;
                });
        },

        async visitQuery(item = {page: 1, itemsPerPage: 10}) {

            this.visits = [];
            this.isLoading = true;

            let {page, itemsPerPage} = this.options;
            page = page || 1;
            itemsPerPage = itemsPerPage || 10;

            const { sortBy = [], sortDesc = [] } =  item;
            let sortField = 'Date', sortDirection = -1;
            if (sortBy.length > 0) sortField = sortBy[0];
            if (sortDesc.length > 0) {
                sortDirection = 1;
                if (sortDesc[0] === undefined || sortDesc[0] === true) sortDirection = -1;
            }


            let today = DateTime.now();
            let lastMonth = DateTime.now().minus({months:1});

            let defaultEndDate = today.toFormat('yyyy-MM-dd');
            let defaultStartDate = lastMonth.toFormat('yyyy-MM-dd');
11
            const params = {
                program: this.reportFilters.program || '',
                startDate: this.reportFilters.startDate || defaultStartDate,
                endDate: this.reportFilters.endDate || defaultEndDate,
                clientId: this.reportFilters.ClientID || '',
                state: this.state || '',
                page: page,
                limit: itemsPerPage,
                clientStatus: this.reportFilters.clientStatus,
                sortField: sortField,
                sortDirection: sortDirection
            };

            await axios.get(`${url}/medicalVisits/reports`, {params})
                .then(response => {
                    const {docs, totalPages, totalDocs} = response.data;
                    this.pageCount = totalPages;
                    this.itemCount = totalDocs;

                    this.visits = docs.map(visits => {
                        if (visits.Date.includes('Z')) {
                            return {
                                ...visits,
                                Date: DateTimeUtil.toLocalDateTime(visits.Date) // Convert to local date only if 'Z' is present.
                            };
                        } else {
                            return {
                                ...visits,
                                Date: visits.Date
                            };
                        }
                    });

                    this.isLoading = false;
                }).finally(() => this.isLoading = false);
        },

        convertKey(data) {
            const output = Object.entries(data).map(([key, value]) => [
                key[0].toLowerCase() + key.slice(1),
                value,
            ]);

            return Object.fromEntries(output);
        },

        close() {
            this.dialog = false;
            this.$nextTick(() => {
                this.item = Object.assign({}, this.defaultItem);
            });
            this.uploadedDocuments = [];
            this.uploadedAdditionalDocuments = [];
            this.newDocuments = [];
            this.newAdditionalDocuments = [];
            this.fileCounter = 1
        },
        showEventDialog(e) {
            this.newEvent = true;
            this.$store.commit("events/SET_DIALOG", e);
            this.item.followUp = e;
            console.log(e);
        },

        printTable() {
            this.options.itemsPerPage = -1;
            this.visitQuery();
            window.print();
        }
    }
}
</script>
<style>
#print {
    display: none
}

@media only screen and (min-width: 768px) {
    .mobile {
        display: none;
    }
}

@media only screen and (max-width: 600px) {
    .desktop {
        display: none;
    }

}


@media only screen and (min-width: 768px) {
    .mobile {
        display: none;
    }
}

@media only screen and (max-width: 600px) {
    .desktop {
        display: none;
    }

}

@media print {
    #print {
        display: block;
        border: none;
        width: 1200px;
        padding-right: 300px;
        margin-left: -200px;
    }


    nav.v-navigation-drawer, header.v-toolbar, button.v-btn, div.v-card {
        display: none;
        border: none;

    }

    @page {
        margin: 0;
    }

    body {
        margin: 1.6cm;
    }


}
</style>
